import { SETTINGS_ROUTES } from "../../routes";

export const SettingsRoute = [
  {
    path: SETTINGS_ROUTES.Settings,
    lazy: async () => {
      const { Settings } = await import("../../../domains/Settings");
      return { element: <Settings /> };
    },
  },
];
